import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { TD1Report } from "../../../components/Reports/TD1Report";

export interface ITD1ReportPage {}

export const TD1ReportPage: FC<ITD1ReportPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="TD1 Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<TD1Report />}
		/>
	);
};
